import { cn } from "../../../lib/utils";

export default function DashboardSection({
	children,
	title,
	className,
	containerClassName,
}) {
	return (
		<div
			className={cn("w-full flex flex-col flex-grow", {
				[containerClassName]: containerClassName,
			})}
		>
			<div className="bg-[#CECECE] px-3.5 py-1.5 w-full flex-shrink">
				<h3 className="font-bold leading-[100%] text-sm text-[#242424]">
					{title}
				</h3>
			</div>
			<div
				className={cn("p-3.5 bg-white w-full flex-grow", {
					[className]: className,
				})}
			>
				{children}
			</div>
		</div>
	);
}
